'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductBadge({
  background,
  color,
  text,
  className,
}: {
  background: string;
  color: string;
  text: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'ea-product-badge',
        'flex h-[19px] items-center justify-center rounded-full px-[6px] text-[10px] font-normal tracking-tight antialiased',
        className,
      )}
      style={{ backgroundColor: background, color: color ?? '#ffffff' }}
    >
      {text}
    </div>
  );
}
